export enum AppIdentifier {
  Account = "account",
  AdminControlCenter = "admin-control-center",
  Dashboard = "dashboard",
  FbsHub = "fbs-hub",
  GasShop = "gas-shop",
  FinishRegistration = "finish-registration",
  Equivolt = "equivolt",
  GeneralError = "general-error",
  Login = "login",
  Maintenance = "maintenance",
  Registration = "registration",
  ThgQuote = "thg-quote",
  WccManagement = "wcc-management",
  WestfalenIdAccountManagement = "westfalen-id-account-management",
  WscManagement = "wsc-management",
}
